var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"packet"},[_c('v-container',[_c('h1',{staticClass:"text-center display-4 grey--text text--darken-2 ma-5",attrs:{"color":""}},[_vm._v("April Fools!")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }